import { useMemo } from "react";
import { useQuery } from "react-query";
import { getStatements } from "../../api/statements";

export default function useGetStatements(options) {
  const {
    data: result,
    refetch,
    isFetching,
    isRefetching,
  } = useQuery("get-statements", () => getStatements(), {
    staleTime: 120 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });

  const formattedResult = useMemo(
    () => ({
      ...result,
      refetch,
      isFetching,
      isRefetching,
      data: result?.data?.['hydra:member'] || [],
    }),
    [result, refetch, isFetching, isRefetching]
  );

  return formattedResult;
}
